var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCampfire = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.755 3.133A.5.5 0 0 0 12.411 3a.527.527 0 0 0-.351.133C10.892 4.188 9.9 5.387 9.2 6.535c-.691 1.133-1.14 2.352-1.14 3.29 0 3.117 2.472 5.676 5.625 5.676 3.121 0 5.625-2.559 5.625-5.676 0-.715-.34-1.809-.847-2.805-.52-1.012-1.254-2.078-2.126-2.883a.518.518 0 0 0-.703 0c-.34.312-.652.695-.93 1.047a19.394 19.394 0 0 0-1.949-2.051zm2.688 9.563a2.991 2.991 0 0 1-1.723.531c-1.582 0-2.848-1.03-2.848-2.77 0-.851.527-1.597 1.582-2.91.14.176 2.18 2.805 2.18 2.805L15.9 8.86c.105.14.176.285.246.426.633 1.172.352 2.664-.703 3.41zm-10.087 1.63a1.25 1.25 0 1 0-.84 2.355l5.454 1.945-5.458 1.95a1.252 1.252 0 0 0 .844 2.356l8.329-2.977 8.329 2.976a1.25 1.25 0 1 0 .84-2.355l-5.454-1.95 5.454-1.95c.648-.23.988-.948.757-1.597a1.254 1.254 0 0 0-1.597-.758l-8.33 2.977-8.328-2.973z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCampfire, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/campfire.a37267f4.svg";
export { ForwardRef as ReactComponent };